module.exports = __webpack_public_path__ + "img/login.98ca20a8.png";